import React from 'react';
import './animation003.less';
import { usePlayFlag } from './../../components/topicScroll';

interface IAnimation003Item {
  icon?: string;
  title: string;
  content: string;
}

const bgTemplate = ['#571f02', '#cf4901', '#eb8b00', '#db546a', '#ffb600'];

const getBG = (feed: number) => bgTemplate[feed % bgTemplate.length];

interface IAnimation003Props {
  items: IAnimation003Item[];
  style?: React.CSSProperties;
  title?: string | null;
  onCompleted?: () => void;
}

const Animation003: React.FunctionComponent<IAnimation003Props> = ({
  title,
  items,
  style,
  onCompleted,
}) => {
  const crrRef = React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);
  const startPlay = (next = 1) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1200);
    } else {
      console.log('Animation003 onCompleted');
      onCompleted && onCompleted();
    }
  };

  React.useEffect(() => {
    if (playFlag) {
      startPlay();
    }
  }, [playFlag]);
  return (
    <div ref={crrRef} className="animation003 component" style={style}>
      {title && (
        <div
          className="animation003-title"
          dangerouslySetInnerHTML={{ __html: title }}
        />
      )}
      <div className="animation003-content">
        {items.map((itm: IAnimation003Item, idx: number) => (
          <div
            key={idx}
            className={`animation003-item animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
            style={{ width: `${(1 / items.length) * 100}%` }}
          >
            <div
              className="animation003-header"
              style={{
                backgroundColor: getBG(idx),
              }}
            >
              {itm.icon && (
                <div>
                  <img src={itm.icon} alt="" />
                </div>
              )}
              <span dangerouslySetInnerHTML={{ __html: itm.title }} />
            </div>
            <div
              className="animation003-text"
              style={{ borderColor: getBG(idx) }}
              dangerouslySetInnerHTML={{ __html: itm.content }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

Animation003.defaultProps = {
  style: {},
  title: null,
};

export default Animation003;
